import { Box, FormHelperText } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  useWsEditor,
  Label,
  WsEditor,
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
} from 'wisestep-base';

interface IJobDescriptionComponentProps {
  name: string;
  description?: string;
  mandatory?: boolean;
  showSuccessLabel?: boolean;
  errors?: any;
}

const JobDescriptionComponent = ({
  name,
  description,
  mandatory = false,
  showSuccessLabel = false,
  errors = {},
}: IJobDescriptionComponentProps) => {
  const { setValue } = useFormContext();
  const jdEditor = useWsEditor(description || '', (htmlBody) => {
    setValue(name, htmlBody ?? '');
  });
  useEffect(() => {
    if (!jdEditor || jdEditor.isDestroyed) return;
    if (!isEmpty(description)) {
      setValue(name, description);
      jdEditor?.commands?.setContent(description || '');
    }
  }, [description, jdEditor, name, setValue]);

  return (
    <>
      <Label>
        Job Description
        {mandatory ? ' *' : ''}
      </Label>
      <Box
        minHeight={200}
        sx={{ border: showSuccessLabel ? '2px solid #4caf50' : '1px solid #e0e0e0' }}
      >
        <WsEditor key="description" editor={jdEditor} resizable={true} />
      </Box>
      {showSuccessLabel && (
        <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.SUCCESS}>
          {'Job Description Enhanced with AI'}
        </WsTypography>
      )}
      <FormHelperText error={!!errors.description}>{errors.description?.message}</FormHelperText>
    </>
  );
};

export default JobDescriptionComponent;
